var map = {
	"./de/warrior-name.png": "aJSR",
	"./en/warrior-name.png": "Qu6o",
	"./es/warrior-name.png": "PJvT",
	"./fr/warrior-name.png": "BRZv",
	"./ja/warrior-name.png": "s7UX",
	"./ko/warrior-name.png": "V1VV",
	"./pt/warrior-name.png": "iO27",
	"./ru/warrior-name.png": "9si9",
	"./th/warrior-name.png": "1RCO",
	"./zh-Hant/warrior-name.png": "3Rhd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SxXJ";